import { render, staticRenderFns } from "./tagsListing.vue?vue&type=template&id=d666ae0e&scoped=true"
import script from "./tagsListing.vue?vue&type=script&lang=js"
export * from "./tagsListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d666ae0e",
  null
  
)

export default component.exports